
import { instance } from './_config.js'



const getConsolidations = async (obj) => {
    try {
        const rs = await instance.post(`/consolidations/search`, obj)
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateConsolidation = async (obj) => {
    try {
        const rs = await instance.post(`consolidations`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const deleteConsolidation = async (id) => {
    try {
        const rs = await instance.delete(`consolidations`, { data: { '_id': id }})
        if (rs.data) {
            return rs.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


export { getConsolidations, updateConsolidation, deleteConsolidation }